<template>
  <Menu></Menu>
  <div id="box">
    <div v-if="loading" class="loadingSpinner"><span class="spinner-border"></span></div>
    <!-- =========================================================================================================== -->
    <div class="container mb-2">
      <div class="row p-0">
        <div class="col p-0 text-center">
          <h5 class="fw-bold d-inline-block bi-clock-history">&nbsp; <i class="bi-person-fill-gear"></i> &nbsp; Users Logs</h5>
        </div>
        <!-- <div class="col-auto p-0 text-center">
          <button class="btn btn-dark w-100 bi-arrow-clockwise" @click="loadLogs()" :disabled="loading">&nbsp; Reload</button>
        </div> -->
      </div>
      <!-- ----------------------------------------------- -->
      <div class="row p-0">
        <div class="col p-0">
          <hr>
        </div>
      </div>
      <!-- ----------------------------------------------- -->
      <div class="row p-0">

        <div class="col-3 p-0">
          <div class="input-group w-100">
            <span class="input-group-text w-25">User</span>
            <select class="form-select" v-model="user_id">
              <option value="*">All Users</option>
              <option v-for="u in users" :key="u._id" :value="u._id">{{ u.username }}</option>
            </select>
          </div>
        </div>
        
        <div class="col-8">
          <div class="input-group w-100">
            <span class="input-group-text">From</span>
            <input class="form-control w-20" type="date" v-model="from">
            <span class="input-group-text">To</span>
            <input class="form-control w-20" type="date" v-model="to">
          </div>
        </div>
        
        <div class="col-1 p-0">
          <button class="btn btn-primary w-100 bi-filter" @click="loadLogs()" :disabled="loading">&nbsp; Filter</button>
        </div>

      </div>
    </div>
    <!-- =========================================================================================================== -->
    <table class="table table-sm table-bordered table-striped table-hover table-fixed">
      <!-- ----------------------------------------------- -->
      <thead>
        <tr class="table-dark">
          <th v-bind:class="$store.getters.isSuper ? 'w-10': 'w-30'">User</th>
          <th v-bind:class="$store.getters.isSuper ? 'w-10': 'w-15'">Action</th>
          <th class="w-15">Time</th>
          <th class="w-10">IP</th>
          <th class="w-15">Platform</th>
          <th class="w-15">Browser</th>
          <th v-if="$store.getters.isSuper" class="w-25">Details</th>
        </tr>
      </thead>
      <!-- ----------------------------------------------- -->
      <tbody style="height: calc(100vh - 190px)">        
        <tr v-for="log in logs" :key="log._id" :class="log.blocked ? 'table-danger' : (log.action == 'Login' ? 'table-success' : '')">
          <td v-bind:class="$store.getters.isSuper ? 'w-10': 'w-30'">{{ log.user }}</td>
          <td v-bind:class="$store.getters.isSuper ? 'w-10': 'w-15'">{{ log.action }}</td>
          <td class="w-15">{{ log.timestamp }}</td>
          <td class="w-10">{{ log.ip }}</td>
          <td class="w-15">{{ log.platform }} {{ log.os }}</td>
          <td class="w-15">{{ log.browser }} {{ log.version }}</td>
          <td v-if="$store.getters.isSuper" class="w-25 fixWidth"><pre>{{ JSON.stringify(JSON.parse(log.details), null, 2) }}</pre></td>
        </tr>
      </tbody>
      <!-- ----------------------------------------------- -->
    </table>
  </div>

</template>
<!-- ******************************************************** -->
<script>
  export default {
    name: 'LogsPage',
    props: {
      id: {
        type: String,
        default: '',
      },
    },
    data(){
      return {
        loading: false,
        
        users: [],
        logs: [],
        user_id: '*',
        from: '',
        to: '',
      }
    },
    async created() {
      this.from = this.$getMonthStart();
      this.to = this.$getMonthEnd();
      await this.loadUsersAbstract();
      
      this.user_id = this.$route.params.id || '*';      
      await this.loadLogs();
    },
    //**********************************************************
    methods:{
      //**********************************************************
      async loadUsersAbstract(){
        this.loading = true;
        this.users = [];
        var ack = await this.$service.loadUsersAbstract();
        if(ack.state != 'OK'){
          this.$toast(ack.state);
        }
        else{
          this.users = ack.data;
        }
        this.loading = false;
      },
      //**********************************************************
      async loadLogs(){
        this.loading = true;
        this.logs = [];
        var ack = await this.$service.loadLogs({
          user: this.user_id,
          from: this.from,
          to: this.to,
        });
        if(ack.state != 'OK'){
          this.$toast(ack.state);
        }
        else{
          this.logs = ack.data;
          this.logs = ack.data;
        }
        this.loading = false;
      },
      //**********************************************************
      async resolveColor(log){
        if(log.blocked) return 'table-danger';
        if(log.action == 'Login') return 'table-success';
        return '';
      },
      //**********************************************************
    }
  }
</script>
<!-- ******************************************************** -->
<style scoped>
table td {
    white-space: normal !important; 
    word-wrap: break-word !important;
}
.fixWidth{
  width: 50px !important;
  white-space: normal !important; 
  word-wrap: break-word !important;
}
table *{
    font-size: 11pt !important;
}
</style>
  